"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.profile.title': 'Editar Perfil',
    'user.profile.back': 'Volver al Panel',
    'user.profile.name.label': 'Nombre Completo',
    'user.profile.name.placeholder': 'Juan Pérez',
    'user.profile.username.label': 'Usuario',
    'user.profile.username.placeholder': 'juanperez',
    'user.profile.email.label': 'Correo Electrónico',
    'user.profile.email.placeholder': 'correo@direccion.com',
    'user.profile.picture.label': 'Foto de Perfil',
    'user.profile.picture.placeholder': 'Elegir foto de perfil...',
    'user.profile.picture.remove': '×',
    'user.profile.changePassword.title': 'Cambiar Contraseña',
    'user.profile.changePassword.description': 'Deja los campos de contraseña vacíos si no quieres cambiar tu contraseña.',
    'user.profile.password.new.label': 'Nueva Contraseña',
    'user.profile.password.placeholder': 'Ingresa nueva contraseña',
    'user.profile.password.repeat.label': 'Repetir Nueva Contraseña',
    'user.profile.password.repeat.placeholder': 'Repetir nueva contraseña',
    'user.profile.submit': 'Actualizar Perfil',
    'user.profile.form.passwordMismatch': 'Las contraseñas no coinciden',
    'user.profile.form.updateFailed': 'Error al actualizar el perfil',
    'user.profile.form.updateSuccess': 'Perfil actualizado exitosamente',
};
